<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <loading/>
            </div>
        </div>
    </div>
</template>

<script>

    import mixin_widget from "@mixins_widget";

    export default {
        name: "ViewsMaintenance",
        mixins: [mixin_widget],
        beforeMount() {

            const params = new URLSearchParams()
            const flow = this.$route.query.flow;

            if (flow && this.widget_flows.includes(flow)) {
                params.set(this.widget_flowParameter, flow);
            } else {
                params.set('wgtopen', 'true')
            }

            window.location.href = `/?${params.toString()}`;
        }
    }
</script>